import { Route, Switch } from "react-router-dom";
import { AcceptInvite } from "./AcceptInvite/AcceptInvite";

/** `/invite`: the invitation pages render their own `EntryFrame`. */
export const InviteHome = () => (
  <Switch>
    <Route>
      <AcceptInvite />
    </Route>
  </Switch>
);
